//1 = light blue, 2 = blue, 3 = yellow, 4 = red

export const wings = [
    0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 
    0, 0, 4, 0, 0, 0, 0, 0, 4, 0, 0, 0, 
    0, 2, 2, 4, 0, 0, 0, 4, 2, 2, 0, 0, 
    0, 2, 2, 2, 2, 0, 2, 2, 2, 2, 0, 0, 
    0, 2, 1, 2, 2, 0, 2, 2, 1, 2, 0, 0, 
    0, 2, 2, 2, 0, 0, 0, 2, 2, 2, 0, 0, 
    0, 2, 2, 2, 0, 0, 0, 2, 2, 2, 0, 0, 
    0, 2, 2, 0, 0, 0, 0, 0, 2, 2, 0, 0, 
    0, 2, 3, 0, 0, 0, 0, 0, 3, 2, 0, 0, 
    0, 3, 0, 0, 0, 0, 0, 0, 0, 3, 0, 0, 
    0, 5, 0, 0, 0, 0, 0, 0, 0, 5, 0, 0, 
    0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
]
